import TerminalHeader from '../TerminalHeader'
import TerminalBody from '../TerminalBody'
import TerminalWrapper from '../TerminalWrapper'

export default {
  Header: TerminalHeader,
  Body: TerminalBody,
  Wrapper: TerminalWrapper,
}
